import type { Texture } from "@babylonjs/core/Materials/Textures/texture";
import {
  MONSTER_ANIMATIONS,
  MONSTER_ATLAS_COLUMNS,
  MONSTER_ATLAS_ROWS,
  type MonsterAnimation,
} from "../assets/MonsterSpriteGenerator";

export class SpriteAnimator {
  private animation: MonsterAnimation = "idle";
  private elapsed = 0;
  private frame = 0;
  private finished = false;

  public constructor(private readonly texture: Texture) {
    texture.uScale = 1 / MONSTER_ATLAS_COLUMNS;
    texture.vScale = 1 / MONSTER_ATLAS_ROWS;
    this.applyFrame();
  }

  public play(animation: MonsterAnimation, restart = false): void {
    if (animation === this.animation && !restart) {
      return;
    }
    this.animation = animation;
    this.elapsed = 0;
    this.frame = animation === "corpse" ? MONSTER_ANIMATIONS.death.frames - 1 : 0;
    this.finished = false;
    this.applyFrame();
  }

  public update(deltaSeconds: number): void {
    const definition = MONSTER_ANIMATIONS[this.animation];
    if (this.finished || this.animation === "corpse") {
      return;
    }
    this.elapsed += deltaSeconds;
    if (this.elapsed < definition.frameSeconds) {
      return;
    }
    this.elapsed %= definition.frameSeconds;
    this.frame += 1;
    if (this.frame >= definition.frames) {
      if (definition.loop) {
        this.frame = 0;
      } else {
        this.frame = definition.frames - 1;
        this.finished = true;
      }
    }
    this.applyFrame();
  }

  public get isFinished(): boolean {
    return this.finished;
  }

  private applyFrame(): void {
    const row = MONSTER_ANIMATIONS[this.animation].row;
    this.texture.uOffset = this.frame / MONSTER_ATLAS_COLUMNS;
    this.texture.vOffset = 1 - (row + 1) / MONSTER_ATLAS_ROWS;
  }
}
